import React, { useState, useEffect, useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { Dot } from 'react-bootstrap-icons'
import ClientListItem from './ClientsListItem'
import SortByDropdown from './SortByDropdown'

import ShowMoreBtn from './ShowMoreBtn'
import { BrowseContext } from '../../../contexts/BrowseContext'

export default observer(function ClientsList() {
  const { browseState, clients, clientListSort } = useContext(BrowseContext)
  const [showMore, setShowMore] = useState(false)

  return (
    <div className='p-8'>
      <div className='flex items-center justify-between'>
        <div className='flex items-center justify-between'>
          <h2 className='font-bold text-lg dark:text-white'>Clients</h2>
          <Dot className='h-7 w-7 rb-text-muted'/>
          <span className='font-bold text-lg rb-text-muted'>{clients.length}</span>
        </div>
        <SortByDropdown
          sortDirection={clientListSort.direction}
          editSortDirection={() => clientListSort.direction === 'desc' ? clientListSort.direction = 'asc' : clientListSort.direction = 'desc'}
          editSortAttribute={option => clientListSort.attribute = option}
        />
      </div>

      <div className="grid grid-cols-3 gap-5 mt-3">
        <button
          className='bg-gray-100 dark:bg-rb-dark-mode rounded-lg border-dashed border-2 border-rb-dash-border dark:border-rb-dark-mode-lighter h-20 font-bold dark:text-white'
          onClick={() => browseState.toggleCreateClient()}
        >
          Create client
        </button>
        {
          showMore ? (
            clients.map(client => <ClientListItem key={client.id} client={client} />)
          ) : (
            clients.slice(0, 8).map(client => <ClientListItem key={client.id} client={client} /> )
          )
        }
      </div>
      <div className="flex justify-end pt-3">
        <ShowMoreBtn showMore={showMore} handleClick={() => setShowMore(!showMore)} />
      </div>
    </div>
  )
})
